import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventsService} from '../../../services/events.service';
import {AnalyticsService} from '../../../services/analytics.service';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
})
export class RadioGroupComponent implements OnInit {
  @Input() items: Array<{text: string, value: string, class: string}>;
  @Input() value = '-2';
  @Input() highlight = '0';
  @Input() disabled= false;
  @Output() valueChange = new EventEmitter();

  constructor(
      private event: EventsService,
      private analytics: AnalyticsService,
  ) { }

  ngOnInit() {}

  select(item) {
      if (!this.disabled){
          this.event.publish('form:changed', 'skills-checker');
          this.value = item.value;
          this.valueChange.emit(this.value);
      }
  }
}
